<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete
      class="text"
      itemvalue="FrmID"
      :disabled="disabled"
      :value="value"
      id="FrmID" itemtext="FrmName"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="full" no-default
      :text="text"
      :clearable="clearable"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sService from "@/services/Technicalassistance/ReceptionSurveillanceService.js";
export default {
  components: {},
  props: {
    hvsId: {
        type: Number,
        default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    foremanID:{
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(value) {
      this.item = value;
    },
    foremanID(){
        this.config.params.FrmId=this.foremanID
    },
    hvsId(newVal) {
        this.config.params.HvsId = newVal;
    }
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    this.config = {
      url: _sService.getUrlListReceptionSurveillanceGang(),
      title: this.label,
      params: { HvsID: this.hvsId, requestID: this.$fun.getUserID()},
    };
  },
};
</script>
